module.exports = __webpack_public_path__ + "static/media/resolver.ffad7b9d.svg";